module.exports = ".dashboard-list li a {\n  color: #fff;\n}"